import * as a from "./action";
import * as s from "./selector";
import withActions from "../../utils/redux/withActions";

// import { sendMessage } from "../Notifications";
// import { startLoading, stopLoading } from "../Suspense";

const {
  setCards,
  setCardImages,
  toggleDisplay,
  setDisplayImage,
  closeImage,
  openImage,
  setCardError,
} = a;

const boundedActions = withActions({
  closeImage,
  openImage,
  // sendMessage,
  setCardImages,
  setCards,
  setDisplayImage,
  // startLoading,
  // stopLoading,
  toggleDisplay,
});

export const fetchCards =
  () =>
  async (dispatch, getState, { history, remote }) => {
    // dispatch(startLoading());

    try {
      const { sellCards } = await remote(
        "get",
        `/v3/cards/sell`,
        {},
        "get sell cards",
        dispatch
      );

      dispatch(setCards(sellCards));
    } catch (error) {
      console.error(error);
    }

    // dispatch(stopLoading());
  };

export const fetchCardImage =
  (cardId) =>
  async (dispatch, getState, { history, remote }) => {
    // dispatch(startLoading());

    try {
      const data = await remote(
        "get",
        `v3/cards/${cardId}/images`,
        {},
        "get sell cards images",
        dispatch
      );

      if (!data.front && !data.back) {
        dispatch(
          setCardError(cardId, {
            error: "There are no images associated with this card",
          })
        );
      } else {
        dispatch(setCardImages(cardId, data));
        dispatch(setDisplayImage(cardId));
        dispatch(openImage());
      }
    } catch (error) {
      dispatch(
        setCardError(cardId, { error: `Failed to fetch images for ${cardId}` })
      );
    }

    // dispatch(stopLoading());
  };
